import React from "react";
import { useSelector } from "react-redux";
import Wrapper from "./footer.styles";
import { fgfChildThemes, nimbleChildThemes } from "@theme/config/theme.config";
import environmentSettings from "@src/constants/environmentSettings";
import BadgeTrustPilot from "@src/containers/PersonalLoan/components/badges/badgeTrustPilot/badgeTrustPilot";

export const ExtendFooter = () => {
  const themeName = useSelector(state => state.StartUp.theme.themeName);
  const extendedFooterThemes = [
    ...fgfChildThemes,
    ...nimbleChildThemes
  ];
  if(extendedFooterThemes.includes(themeName)) {
    return true;
  }
  return false;
}

export function Footer() {
  const { abn, acl } = environmentSettings;

  return (
    <Wrapper className="Footer-Container">
      <p className="ApprovalText" x-ms-format-detection="none">
        All applications are subject to approval and will be assessed separately
        by reference to the applicants individual circumstances. For more
        information regarding our offering, please read our Terms and
        Conditions. <br className="mobile-only"/><br className="mobile-only"/>ABN {abn} | Australian Credit Licence {acl}
      </p>
      <BadgeTrustPilot/>
    </Wrapper>
  );
}
